module.exports = __webpack_public_path__ + "img/interstate-capital.68967364.png";